import React, { useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";

import Paper from "@mui/material/Paper";

import dayjs from "dayjs";

import { useJwtStorage, useLocalStorage } from "../../hooks/useLocalStorage";

import DrawerAppBar from "../../components/DrawerAppBar";
import Title from "../../components/Title";
import SubTitle from "../../components/SubTitle";
import ProgressBar from "../../components/ProgressBar";

import { getCheckinHistory } from "../../services/UserService";

const StudentCheckins = () => {
  const [_jwt] = useJwtStorage();
  const [_school] = useLocalStorage("Auth", "school", null);
  const [_showProgress, setShowProgress] = React.useState(false);

  const [_checkinMetrics, setCheckinMetrics] = React.useState({
    pairs: [],
  });
  const [_totalSeatSeconds, setTotalSeatSeconds] = React.useState("");

  useEffect(() => {
    initHistory();
  }, []);

  const initHistory = () => {
    setShowProgress(true);

    getCheckinHistory(_school, _jwt)
      .then((results) => {
        const checkinMetrics = results.data.checkin_metrics;
        setCheckinMetrics(checkinMetrics);


        let totalSeconds = 0;
        for (let dateKey of Object.keys(checkinMetrics.seconds)) {
          totalSeconds += checkinMetrics.seconds[dateKey];
        }
        setTotalSeatSeconds(totalSeconds);
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const getCategoryText = (item) => {
    let category = (item.isCheckin === 'Y') ? "CHECK IN" : "CHECK OUT";
    if (item.isArtificial === 'Y') { 
      category += " (TBD)";
    }

    return category;
  }

  const getHourMinuteString = (seconds) => {
    const totalHours = seconds / 3600.0;
    const seat_hour = Math.floor(totalHours);
    const seat_minutes = Math.floor((totalHours - seat_hour) * 60.0);
    return `${seat_hour} hours, ${seat_minutes} minutes`;
  };

  return (
    <>
      <DrawerAppBar />

      <Container sx={{ mt: 1 }}>
        <Title text="Student Check In/Check Out Report" showBack={true} />
        <ProgressBar showProgress={_showProgress} />

        <SubTitle text="Key Metrics:" />
        <Grid container spacing={2} sx={{ mt: 0.0, mb: 2 }}>
          <Grid item xs={6}>
            Total Seat Hours:
          </Grid>
          <Grid item xs={6}>
            {getHourMinuteString(_totalSeatSeconds)}
          </Grid>
        </Grid>

        <SubTitle text="History:" />

        {_checkinMetrics.pairs.length === 0 && (
          <div>-- NO RESULTS RETURNED --</div>
        )}

        {Object.keys(_checkinMetrics.pairs).map((date) => (
          <>
            <TableContainer
              component={Paper}
              sx={{ mt: 1, pt: 1, pl: 1, pb: 1 }}
            >
              Date: {date} ({getHourMinuteString(_checkinMetrics.seconds[date])}
              )
              <Table sx={{ minWidth: 400 }} aria-label="checkins table">
                <TableHead>
                  <TableRow>
                    <TableCell>Date Created</TableCell>
                    <TableCell>Category</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {_checkinMetrics.pairs[date].map((pair) => (
                    <>
                      {pair.map((item) => (
                        <TableRow>
                          <TableCell>{dayjs(item.dateCreated).format("MM/DD/YYYY hh:mm a")}</TableCell>
                          <TableCell>{getCategoryText(item)}</TableCell>
                        </TableRow>
                      ))}
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </>
        ))}
      </Container>
    </>
  );
};

export default StudentCheckins;
